import { render, staticRenderFns } from "./signGift.vue?vue&type=template&id=69bb5b9c"
import script from "./signGift.vue?vue&type=script&lang=js"
export * from "./signGift.vue?vue&type=script&lang=js"
import style0 from "./signGift.vue?vue&type=style&index=0&id=69bb5b9c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports